import { connect } from 'react-redux';
import TransactionsModal, {
  TransactionsModalProps,
} from '@/components/DeprecatedPortfolio/components/TransactionsModal';
import type {
  FetchPriceArgs,
  AddTransactionArgs,
} from '@/components/DeprecatedPortfolio/components/TransactionsModal/components/AddTransactions';
import {
  makeIsUpdatingItemPrice,
  makeIsAddingTransaction,
  makeDoesPortfolioNeedsRefresh,
  makeGetItemPriceForPortfolioHolding,
  makeGetHolding,
} from '@/components/DeprecatedPortfolio/redux/selectors';
import {
  fetchPriceForItem,
  addTransactionForPortfolioItem,
  removeTransactionForPortfolioItem,
  updateReinvestDividends,
  hideTransactionsModal,
  fetchPortfolio,
} from '@/components/DeprecatedPortfolio/redux/actions';
import { get } from 'lodash';

const makeMapStateToProps = () => {
  const getIsUpdatingItemPrice = makeIsUpdatingItemPrice();
  const getIsAddingTransaction = makeIsAddingTransaction();
  const getDoesPortfolioNeedsRefresh = makeDoesPortfolioNeedsRefresh();
  const getItemPriceForPortfolioHolding = makeGetItemPriceForPortfolioHolding();
  const getHolding = makeGetHolding();
  const mapStateToProps = (state) => {
    const {
      portfolio: {
        currentId,
        transactionsCurrentItemId,
        transactionsModalStatus,
        transactionsStatus,
      },
      portfolios: { transactionsTable },
    } = state;
    const isUpdatingItemPrice = getIsUpdatingItemPrice(state);
    const holding = getHolding(state, transactionsCurrentItemId);
    const itemPrices = getItemPriceForPortfolioHolding(
      state,
      transactionsCurrentItemId
    );
    const isAddingTransaction = getIsAddingTransaction(
      state,
      currentId,
      (holding && holding.companyId) || ''
    );
    const doesPortfolioNeedsRefresh = getDoesPortfolioNeedsRefresh(state);

    return {
      itemId: transactionsCurrentItemId,
      portfolioId: currentId,
      transactionsModalStatus,
      itemPrices,
      transactions:
        (holding &&
          holding.transactionsMap &&
          holding.transactionsMap.map((n) => transactionsTable[n])) ||
        undefined,
      isUpdatingItemPrice,
      isAddingTransaction,
      transactionsStatus,
      doesPortfolioNeedsRefresh,
      companyId: get(holding, 'companyId', ''),
      tickerSymbol: get(holding, 'tickerSymbol', ''),
      reinvestDividends: get(holding, 'reinvestDividends', false),
      isUpdatingReinvest: get(holding, 'isUpdatingReinvest', false),
    } satisfies Partial<TransactionsModalProps>;
  };
  return mapStateToProps;
};
const mapDispatchToProps = (dispatch) => {
  return {
    handleFetchPriceForItem: (options: FetchPriceArgs) =>
      dispatch(fetchPriceForItem(options)),
    handleAddTransaction: (options: AddTransactionArgs) =>
      dispatch(
        addTransactionForPortfolioItem({
          portfolioId: options.portfolioId,
          companyId: options.portfolioId,
          itemId: options.itemId,
          transactionType: options.type,
          transactionDate: options.date,
          numberOfShares: options.shares,
          transactionCost: options.cost,
        })
      ),
    handleRemoveTransaction: (data) =>
      dispatch(removeTransactionForPortfolioItem(data)),
    handleUpdateReinvest: (data) => dispatch(updateReinvestDividends(data)),
    handlePortfolioRefresh: (portfolioId) => {
      dispatch(fetchPortfolio(portfolioId));
    },
    onClose: () => dispatch(hideTransactionsModal()),
  } satisfies Partial<TransactionsModalProps>;
};

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(TransactionsModal);
